module.exports = __webpack_public_path__ + "c0d0305b7bfea5ac7c2426e1ec2f69bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/powered_by_google_default.png
// module id = 28
// module chunks = 0